import { Button } from '@consta/uikit/Button'
import { ResponsesEmptyBox } from '@consta/uikit/ResponsesEmptyBox'
import type { ProjectId } from 'common/types'
import type { FC } from 'react'
import { useParams } from 'react-router-dom'

import css from './WorkAreas.css'

type TabPlaceholderProps = {
  title: string
  description: string
  urlConstructor?: (projectId: ProjectId) => string
}

export const TabPlaceholder: FC<TabPlaceholderProps> = ({ title, description, urlConstructor }) => {
  const { projectId = '' } = useParams()

  return (
    <ResponsesEmptyBox
      className={css.placeholder}
      title={title}
      description={description}
      size="l"
      actions={
        urlConstructor ? (
          <Button
            label="Открыть сейчас"
            size="m"
            as="a"
            href={urlConstructor(projectId)}
            target="_blank"
          />
        ) : (
          <div />
        )
      }
    />
  )
}
